import * as pages from '../constants/pages';

// Route configuration mapping URL paths to Redux page constants
export const routes = {
  [pages.PAGE_HOME]: '/',
  [pages.PAGE_RESEARCH]: '/research',
  [pages.PAGE_ENGINEERING]: '/engineering',
  [pages.PAGE_SIMULATION]: '/simulation',
  [pages.PAGE_OUTPUTS]: '/outputs',
  [pages.PAGE_BUILD]: '/build',
  [pages.PAGE_JOURNAL]: '/journal',
};

// Page titles for WCAG compliance
export const pageTitles = {
  [pages.PAGE_HOME]: 'Home',
  [pages.PAGE_RESEARCH]: 'Research',
  [pages.PAGE_ENGINEERING]: 'Engineering',
  [pages.PAGE_SIMULATION]: 'Competition',
  [pages.PAGE_OUTPUTS]: 'Outputs',
  [pages.PAGE_BUILD]: 'Build',
  [pages.PAGE_JOURNAL]: 'Journal',
};

// Reverse mapping: URL path to page constant
export const pathToPage = Object.entries(routes).reduce((acc, [page, path]) => {
  acc[path] = page;
  return acc;
}, {});

// Helper to get route path from page constant
export const getRoutePath = (page) => routes[page] || '/';

// Helper to get page constant from route path
export const getPageFromPath = (path) => pathToPage[path] || pages.PAGE_HOME;

// Helper to get page title from page constant
export const getPageTitle = (page, appName = 'WhiteBox Learning') => {
  const pageTitle = pageTitles[page] || 'Home';
  return `${pageTitle} - ${appName}`;
};
